<mat-list-option
  class="list-item list-item-events"
  [class.list-item-events_invitation]="isInvitation()"
  [value]="data?.id"
  [selected]="!loading && selectedId === data?.id"
>
  <div
    matListIcon
    class="list-item__image list-item__image_large"
    [class.tui-skeleton]="loading"
    [class.tui-skeleton_rounded]="loading"
  >
    <app-photo
      size="m"
      [rounded]="true"
      [type]="'photo'"
      [id]="data?.photoId"
      [photoSrc]="data?.photoId ? undefined : '../../../../assets/images/event-default-image.svg'"
      [showPreview]="false"
    ></app-photo>
  </div>
  <div class="list-item__text-box">
    <div class="list-item__line">
      <p
        class="list-item__text list-item__text_grey date"
        [class.tui-skeleton]="loading"
        [class.tui-skeleton_text]="loading"
      >
        {{ data?.dateStart | stringToDate | datePeriod: (data?.dateEnd | stringToDate) }}
      </p>

      <app-badge *ngIf="badgeData" [value]="badgeData.value | translate" [color]="badgeData.color"></app-badge>
    </div>

    <h3
      class="list-item__title list-item__title_line list-item__title_line_3"
      [class.tui-skeleton]="loading"
      [class.tui-skeleton_text]="loading"
    >
      {{ data?.subject }}
    </h3>

    <p
      *ngIf="data?.address"
      class="list-item__text list-item__text_grey address"
      [class.tui-skeleton]="loading"
      [class.tui-skeleton_text]="loading"
    >
      <app-icon class="list-item__icon" [size]="'15px'" [src]="'map-pin'"></app-icon>
      {{ data?.address }}
    </p>
  </div>
</mat-list-option>
